import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import Loading from '@/components/Loading.vue';
import store from '@/store';
import { ref } from 'vue';
import { getMailAddress } from '@/api/careersheetEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    const { emailAddress } = await getMailAddress();
    const email = emailAddress;
    store.commit('userRegistration/setMailAddress', email);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})